import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

// material-ui
import { Box, List, Typography } from '@mui/material';

// project import
import NavItem from './NavItem';
import NavItemCollapse from './NavItemCollapse';

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

const NavGroup = ({ item, level }) => {
  const menu = useSelector((state) => state.menu);
  // const permissions = useSelector((state) => state.user?.permissions);
  //const permissions = JSON.parse(sessionStorage.getItem('permissions')); // Assuming permissions are stored in sessionStorage. Replace with actual implementation.
  const { drawerOpen } = menu;

  const navCollapse = item.children?.map((menuItem) => {
    // if (!permissions.includes(menuItem.feature_code)) {
    //   return null; // Skip menu item if user doesn't have permission to access it.
    // }

    switch (menuItem.type) {
      case 'collapse':
        return <NavItemCollapse key={menuItem.id} item={menuItem} level={level} />;
      case 'item':
        return <NavItem key={menuItem.id} item={menuItem} level={level} />;
      default:
        return (
          <Typography key={menuItem.id} variant="h6" color="error" align="center">
            Fix - Group Collapse or Items
          </Typography>
        );
    }
  });

  return (
    <List
      // subheader={
      //   item.title &&
      //   drawerOpen && (
      //     <Box sx={{ pl: 3, mb: 1.5 }}>
      //       <Typography variant="subtitle2" color="textSecondary">
      //         {item.title}
      //       </Typography>
      //       {/* only available in paid version */}
      //     </Box>
      //   )
      // }
      sx={{ mb: drawerOpen ? 1.5 : 1.5, py: 0, zIndex: 0 }}
    >
      {navCollapse}
    </List>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object
};

export default NavGroup;
